import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-common';
import { SYS_SPACE_RELATIVE_LG } from '@oneaudi/unified-web-alpha-common';
import { Text, Tag, TagGroup, RadioButton } from '@oneaudi/unified-web-components';
import { dynamicStylingHelper } from '../../../../utils';
import { useServicesContext } from '../../../../../context';
import { getProductDescription } from './form-helperRethink';
import { RadioWrapper, RadioWrapperToOverwriteLegacyCSS, ProductWrapper, FinanceModalitiesContainer, } from './financeModal-stylesRethink';
import { useFinanceTranslations } from './finance-i18N';
import { InfoIcon } from './InfoIcon';
export const FinanceModalitiesWrapper = ({ productData, defaultProductData, actualDefaultProductID, setDefaultProductData, setWebCalcErrorMsg, setIsProductChanged, selectedModality, setSelectedModality, vehicle, }) => {
    var _a, _b, _c, _d, _e;
    if (!productData || !productData.length) {
        return null;
    }
    const audiContentService = useServicesContext().getAdditionalService('audi-content-service');
    const configuration = (_c = (_b = (_a = audiContentService.getContent()) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.vtpConfiguration) === null || _c === void 0 ? void 0 : _c.fields;
    const rawCTAButtons = (_e = (_d = configuration.cta) === null || _d === void 0 ? void 0 : _d.map((button) => button.fields)) !== null && _e !== void 0 ? _e : [];
    const vehicleType = vehicle.type;
    const i18n = useFinanceTranslations();
    const groupProductData = productData &&
        Array.isArray(productData) &&
        (productData === null || productData === void 0 ? void 0 : productData.reduce((acc, item) => {
            if (!acc[item['@Type']])
                acc[item['@Type']] = [];
            acc[item['@Type']].push(item);
            return acc;
        }, {}));
    const groupKeys = rawCTAButtons.some((cta) => cta.type === 'glc-cash-checkout' || cta.type === 'cash-checkout')
        ? [...Object.keys(groupProductData), 'Cash']
        : [...Object.keys(groupProductData)];
    const selectedProductData = Array.isArray(productData) && selectedModality
        ? groupProductData[selectedModality]
        : productData;
    const tagGroupEvent = (key) => {
        if (key !== 'Cash') {
            setDefaultProductData(groupProductData[key][0]);
        }
        setSelectedModality(key);
        setWebCalcErrorMsg('');
        setIsProductChanged(true);
    };
    const headlineTxt = vehicleType === 'U' ? i18n === null || i18n === void 0 ? void 0 : i18n.modalitiesUCHeading : i18n === null || i18n === void 0 ? void 0 : i18n.modalitiesNCHeading;
    return (React.createElement(FinanceModalitiesContainer, null,
        React.createElement("div", null,
            React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '1', style: 'bold' }, margin: [0, 0, dynamicStylingHelper(SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_LG), 0], key: headlineTxt, className: "default-color-text" }, headlineTxt),
            groupProductData && groupKeys.length > 0 && (React.createElement(TagGroup, { "data-testid": "test-id", margin: [0, 0, 0, 0], size: "md" }, groupKeys.map((key) => key &&
                vehicleType && (React.createElement(TagItem, { labelKey: key, vehicleType: vehicleType, selectedModality: selectedModality, tagGroupEvent: tagGroupEvent })))))),
        selectedModality !== 'Cash' && (React.createElement(ProductWrapper, null,
            Array.isArray(productData) &&
                Array.isArray(selectedProductData) &&
                selectedProductData.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(RadioWrapper, { legend: i18n === null || i18n === void 0 ? void 0 : i18n.productHeadline }, selectedProductData.map((product) => {
                    const radioBtnAriaLabel = useI18n({
                        id: `stockcars.financing.dynamic.overlay.arialabel.input.${product['@ID']}`,
                        defaultMessage: product.Label['#text']
                            ? product.Label['#text']
                            : product.Label,
                    });
                    const infoBtnAriaLabel = useI18n({
                        id: `stockcars.financing.dynamic.overlay.arialabel.moreinfo.${product['@ID']}`,
                        defaultMessage: `${product['@ID']}`,
                    });
                    return (React.createElement(RadioWrapperToOverwriteLegacyCSS, { key: `product-section-${product['@ID']}` },
                        React.createElement(RadioButton, { "aria-label": radioBtnAriaLabel, onChange: () => {
                                setDefaultProductData(product);
                                setWebCalcErrorMsg('');
                                setIsProductChanged(true);
                            }, key: `${product['@ID']}`, value: product['@ID'], id: product['@ID'], name: "product", checked: product['@ID'] ===
                                (Array.isArray(defaultProductData) && defaultProductData.length > 1
                                    ? defaultProductData === null || defaultProductData === void 0 ? void 0 : defaultProductData.find((element) => actualDefaultProductID === element['@ID'])['@ID']
                                    : defaultProductData['@ID']), label: product.Label['#text'] ? product.Label['#text'] : product.Label }),
                        product.Description && (React.createElement(InfoIcon, { ariaLabel: infoBtnAriaLabel, popupContent: getProductDescription(product.Description), key: `prodct-icon-button-${product.Label}`, iconSize: dynamicStylingHelper('md', 'xs'), alignment: "left" }))));
                })))),
            !Array.isArray(productData) &&
                typeof productData === 'object' &&
                productData['Label'] && (React.createElement(React.Fragment, null,
                React.createElement(RadioWrapper, { legend: i18n === null || i18n === void 0 ? void 0 : i18n.productHeadline, key: i18n === null || i18n === void 0 ? void 0 : i18n.productHeadline },
                    React.createElement(RadioWrapperToOverwriteLegacyCSS, null,
                        React.createElement(RadioButton, { "aria-label": useI18n({
                                id: `stockcars.financing.dynamic.overlay.arialabel.input.${productData['@ID']}`,
                                defaultMessage: productData['Label']['#text']
                                    ? productData['Label']['#text']
                                    : productData['Label'],
                            }), key: `${productData['@ID']}`, value: productData['@ID'], id: productData['@ID'], checked: productData['@ID'] ===
                                (Array.isArray(defaultProductData) && defaultProductData.length > 1
                                    ? defaultProductData === null || defaultProductData === void 0 ? void 0 : defaultProductData.find((element) => actualDefaultProductID === element['@ID'])['@ID']
                                    : defaultProductData['@ID']), onChange: () => { }, name: "product", label: productData['Label']['#text']
                                ? productData['Label']['#text']
                                : productData['Label'] }),
                        productData['Description'] && (React.createElement(InfoIcon, { ariaLabel: useI18n({
                                id: `stockcars.financing.dynamic.overlay.arialabel.moreinfo.${productData['@ID']}`,
                                defaultMessage: `${productData['@ID']}`,
                            }), key: `prodct_${productData['Label']}`, popupContent: getProductDescription(productData['Description']), iconSize: dynamicStylingHelper('md', 'xs'), alignment: "left" }))))))))));
};
export const TagItem = ({ labelKey, vehicleType, selectedModality, tagGroupEvent, }) => {
    const modifiedKey = labelKey === null || labelKey === void 0 ? void 0 : labelKey.toLocaleLowerCase();
    const modifiedType = vehicleType === 'N' ? 'nc' : 'uc';
    const tagGroupAriaLabel = useI18n({
        id: `stockcars.${modifiedType}.financing.${modifiedKey}.edit.arialabel.${modifiedKey}`,
        defaultMessage: labelKey,
    });
    const tagGroupLabel = useI18n({
        id: `stockcars.${modifiedType}.financing.group.${modifiedKey}`,
        defaultMessage: labelKey,
    });
    return (React.createElement(Tag, { "aria-label": tagGroupAriaLabel, checked: labelKey === selectedModality, "data-testid": `${modifiedKey}-id`, key: labelKey, label: tagGroupLabel, margin: [0, 0, 0, 0], name: "selectable", onChange: () => tagGroupEvent(labelKey), onClick: () => tagGroupEvent(labelKey), size: "md", value: "selectable-tag", variant: "selectable" }));
};
